import React, { useEffect, useState } from 'react'
import Image from 'next/image'

import { UserChoicesAndWrongs } from 'store/userChoicesAndWrongsGroup'
import useExamInform, { AnswerResult } from '@hooks/useExamInform'
import UseCurrentPage from '@hooks/useCurrentPage'
import useViewResultModeStore from 'store/viewResultMode'

import OmrChoiceNumbers from './OmrChoiceNumbers'

export type OmrQuestionSheetProps = {
  goToQuestion: (num: number) => void
  isDelivery?: boolean
}

const OmrQuestionSheet = ({ goToQuestion, isDelivery }: OmrQuestionSheetProps) => {
  const { viewResultMode } = useViewResultModeStore()
  const [allQA, setAllQA] = useState<UserChoicesAndWrongs>({})
  const [numberOfQuestions, setNumberOfQuestions] = useState(0)
  const {
    currentQuestionGroup,
    userChoicesAndWrongsGroup,
    updateQuestionChoiceOfCurrentGroup,
    answerResultsGroup,
  } = useExamInform(isDelivery)
  const { isQuestionInCurrentPage } = UseCurrentPage()

  useEffect(() => {
    setNumberOfQuestions(currentQuestionGroup?.questions?.length || 80)
  }, [currentQuestionGroup?.questions?.length])

  useEffect(() => {
    const getQA = async () => {
      const group = userChoicesAndWrongsGroup[currentQuestionGroup.id || 0]
      if (currentQuestionGroup.id && group) {
        setAllQA(group)
      }
    }
    getQA()
  }, [userChoicesAndWrongsGroup, currentQuestionGroup])

  const answerResult =
    currentQuestionGroup.id &&
    answerResultsGroup[currentQuestionGroup.id]?.answerResultsByQuestionNumber

  const renderingQuestionNumber = () => {
    const questionLabels = []
    const setChoice = (questionNumber: number) => {
      const inCurrentPage = isQuestionInCurrentPage(questionNumber)
      return (choice: number) => {
        inCurrentPage
          ? updateQuestionChoiceOfCurrentGroup(questionNumber, choice)
          : goToQuestion(questionNumber)
      }
    }
    for (let questionNumber = 1; questionNumber < numberOfQuestions + 1; questionNumber++) {
      const is5nth = questionNumber % 5 === 0 && questionNumber !== numberOfQuestions
      const choice = allQA[questionNumber]?.choice
      const resultCollection: AnswerResult | undefined = answerResult
        ? answerResult[questionNumber]
        : undefined
      const answer = resultCollection?.answer
      const result = resultCollection?.result
      questionLabels.push(
        <div key={questionNumber} className={'flex'}>
          <div className={'flex justify-center items-center w-[50px]'}>
            {viewResultMode && (
              <Image
                className={'mt-5'}
                src={result ? '/exam/correctCircle.png' : '/exam/wrongCross.png'}
                alt={result ? '정답입니다!' : '오답입니다'}
                width={'24'}
                height={'24'}
              />
            )}
          </div>
          <div className={'w-[30px] text-cbtLayout bg-D2DDED'}>
            <div
              className={`q-no text-center font-bold mt-5 text-lg cursor-pointer ${
                is5nth ? 'mb-5' : 'mb-0'
              }`}
              onClick={() => goToQuestion(questionNumber)}
            >
              <span key={'question' + questionNumber}>
                {questionNumber < 10 ? `0${questionNumber}` : questionNumber}
              </span>
            </div>
          </div>
          <OmrChoiceNumbers
            questionNumber={questionNumber}
            choice={choice || 0}
            setChoice={setChoice(questionNumber)}
            viewResultMode={viewResultMode}
            answer={answer}
            questionsCount={numberOfQuestions}
          />
        </div>
      )
      if (is5nth) {
        questionLabels.push(
          <hr key={`${questionNumber}-h`} className={'border-blue-900 border-dotted'} />
        )
      }
    }

    return questionLabels
  }

  return <div className="orm">{renderingQuestionNumber()}</div>
}

export default React.memo(OmrQuestionSheet)
